import { Navigate, useLocation, } from "react-router-dom";
import { useState } from "react";
import { AuthService } from "../services/auth-service";

// Route-level role bounce. Pass disallowRoles=['student'] on TA-only routes
// to send any student account that types/bookmarks the URL straight back to
// /student-app instead of letting them load TA UI (which then has to bounce
// back from inside the component, briefly flashing the wrong interface).
//
// allowRoles is the inverse: only the listed roles may render this route,
// everyone else is redirected. Use one or the other, not both.
const ROLE_LANDING = {
    student: '/student-app',
    study: '/app',
    math: '/math',
};

function ProtectedRoute({component: Component, allowRoles, disallowRoles, ...rest }) {
    const location = useLocation();
    const [isauth, setIsAuth] = useState(null);

    if (isauth !== null) {
        if(isauth === 'cors error'){
            return <Navigate replace={true} to="/login" state={{ from: `${location.pathname}${location.search}` }} />
        }else if (Object.keys(isauth).length !== 0) {
            const role = isauth.role;
            if (disallowRoles && disallowRoles.includes(role)) {
                return <Navigate replace={true} to={ROLE_LANDING[role] || '/home'} />;
            }
            if (allowRoles && !allowRoles.includes(role)) {
                return <Navigate replace={true} to={ROLE_LANDING[role] || '/home'} />;
            }
            return <Component userdata= {isauth} />
        } else {
            return <Navigate replace={true} to="/login" state={{ from: `${location.pathname}${location.search}` }} />
        }
    }

    new AuthService().me(setIsAuth);
}

export { ProtectedRoute }